class FreeShippingBar {
  constructor() {
    this.threshold = 4800; // 48,00€ en centimes
    this.bar = document.querySelector('[data-cart-shipping-bar]');
    this.init();
  }

  init() {
    if (!this.bar) return;
    document.addEventListener('cart:updated', this.updateBar.bind(this));
    this.updateBar();
  }

  updateBar() {
    this.fetchCartTotal().then(total => {
      this.updateProgress(total);
    });
  }

  async fetchCartTotal() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.total_price;
    } catch (error) {
      console.error('Erreur lors de la récupération du panier:', error);
      return 0;
    }
  }

  updateProgress(cartTotal) {
    if (!this.bar) return;

    const remaining = this.threshold - cartTotal;
    const progressPercent = Math.min((cartTotal / this.threshold) * 100, 100);

    const progressBar = this.bar.querySelector('[data-progress-bar]');
    if (progressBar) {
      progressBar.style.width = `${progressPercent}%`;
    }

    const message = this.bar.querySelector('.free-shipping-bar__message');
    const amountElement = this.bar.querySelector('.free-shipping-bar__amount');
    
    if (remaining > 0) {
      if (message) {
        message.classList.remove('free-shipping-bar__message--success');
      }
      if (amountElement) {
        amountElement.textContent = this.formatMoney(remaining);
      }
    } else {
      if (message) {
        message.classList.add('free-shipping-bar__message--success');
        message.innerHTML = `
          <span class="free-shipping-bar__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </span>
          <strong>Livraison gratuite débloquée !</strong>
        `;
      }
    }
  }

  formatMoney(cents) {
    const euros = cents / 100;
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(euros);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FreeShippingBar();
  });
} else {
  new FreeShippingBar();
}

document.addEventListener('cart:refresh', () => {
  new FreeShippingBar();
});